import { $, addAction } from '@situation/setdesign.util';

const MODAL_BG_ATTR = 'data-modal-bg';

const getPresetForModal = (modalId) => {
    if (!modalId) return null;

    const presets = window.sit?.modalBgPresets || {};
    return presets[modalId] || null;
};

const buildBackgroundElement = (presetKey) => {
    const $element = $('<div/>', {
        class: `modal__bg modal__bg--${presetKey}`,
        attr: { [MODAL_BG_ATTR]: presetKey },
    });
    const animationHtml = window.sit?.bgAnimations?.html?.[presetKey];
    if (animationHtml) {
        $element.append($(animationHtml));
    }
    return $element;
};

addAction('showModal', ($modal) => {
    const modalId = $modal.attr('id');
    const presetKey = getPresetForModal(modalId);
    if (!presetKey) return;

    const $container = $modal.find('.modal__container');
    if (!$container.length || $container.find(`[${MODAL_BG_ATTR}]`).length) {
        return;
    }

    const $background = buildBackgroundElement(presetKey);
    $container.prepend($background);
});

addAction('hideModal', ($modal) => {
    $modal.find(`[${MODAL_BG_ATTR}]`).remove();
});
